import { InputAdornment, MenuItem, Select } from "@mui/material";

function FilterAddress({ value, onChange }) {
  return (
    <Select
      value={value}
      fullWidth
      onChange={(event) => onChange(event.target.value)}
      sx={{ "&.MuiOutlinedInput-root ": { borderRadius: 2 } }}
      startAdornment={
        <InputAdornment position="start">
          <img src="/assets/icons/ic_location.svg" className="w-5 h-5" />
        </InputAdornment>
      }
    >
      <MenuItem value="all">Tất cả</MenuItem>
      <MenuItem value="Hà nội">Hà nội</MenuItem>
    </Select>
  );
}

export default FilterAddress;
